// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { formatCompanyName } from '@zapier/billing/src/utils';
import { jsx } from '@emotion/core';

type Props = {
  accountName?: string,
  companyName?: string,
  heading: string,
  subheading?: string,
};

const accountNameCss = {
  textDecoration: 'underline',
};

const headerCss = {
  marginBottom: '4rem',
};

const headingCss = {
  color: Colors.deepSpace,
  fontSize: '1.8em',
  fontWeight: 600,
  marginTop: '1em',
  padding: 0,
  textAlign: 'center',
};

const subHeadingCss = {
  color: Colors.steel,
  fontSize: '1em',
  marginTop: 20,
  textAlign: 'center',
};

const ChangePlanHeader = (props: Props) => {
  return (
    <header css={headerCss}>
      <h1 css={headingCss}>{props.heading}</h1>
      {props.subheading && (
        <div css={subHeadingCss}>
          {props.subheading}:{' '}
          <span css={accountNameCss}>{props.accountName}</span>{' '}
          {formatCompanyName(props.companyName)}
        </div>
      )}
    </header>
  );
};

export default ChangePlanHeader;
